define('lq/events/actions/checkIn',[
    'lq/events/actions/eventAction',
    'lq/uploader'
], function (EventAction, Uploader) {
	    'use strict';

	    function CheckIn(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

	    EventAction.extend(CheckIn, EventAction);

        CheckIn.typeName = 'CheckIn';

	    CheckIn.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    CheckIn.prototype.createEventActionRequest = function () {
            var self = this;

            return function (requestContinuation) {
                new Uploader(self.piping)
                    .toTenantUrl("DynamicContent/AddTempFile")
                    .onFileUploaded(function (uploadResponse) {
                        if (!uploadResponse.success)
                            throw new Error('Upload failed.');

                        var request = {
                            eventActionType: "CheckIn",
                            morphId: self.eventData.command,
                            fileName: uploadResponse.filename,
                            tempUrl: uploadResponse.tempUrl
                        };
                        requestContinuation(request);
                    })
                    .uploadSingleFile();
            };
	    };

	    return CheckIn;
    }
);
